module.exports = __webpack_public_path__ + "img/buildings.7ce6977b.svg";